export default __webpack_public_path__ + "static/media/add_black.746909a8.svg";